/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'users': {
    width: 20,
    height: 14,
    viewBox: '0 0 20 14',
    data: '<path pid="0" d="M9.731 7.61l2.158-.957a.743.743 0 0 1 .728.088 2.4 2.4 0 0 0 2.862-.001.74.74 0 0 1 .728-.086l1.873.794a.739.739 0 0 1 .422.494l.695 2.687a.74.74 0 0 1-.716.925h-5.827l.177.684a.808.808 0 0 1-.783 1.01H1.043a.808.808 0 0 1-.782-1.01l.862-3.336a.805.805 0 0 1 .467-.542l2.32-.984a.81.81 0 0 1 .795.096 3.085 3.085 0 0 0 3.681 0 .811.811 0 0 1 .798-.095l.547.232zm-.107-3.973a3.078 3.078 0 1 1-6.157.002 3.078 3.078 0 0 1 6.157-.002zm6.815.306a2.392 2.392 0 1 1-4.784 0 2.392 2.392 0 0 1 4.784 0z" _fill="#BCBCBC" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/users.js